/**
 * 按 ageBand 取值的文案表(语气表)。
 *
 * 6-8 岁保持原有的亲切口吻;9-12 岁用更克制、成熟的国风语气。
 * 约束:界面不出现"测试/题目/对错"字样;答错只温和提示。
 * 新增文案请加到这里,不要在组件里按年龄段写 if。
 */
export const COPY = {
  '6-8': {
    eggSubtitle: '选择你的灵兽起源,开启大脑觉醒之旅!',
    retryHint: '哎呀,差一点!再看看呀 ✨',
    capsuleButton: '明白啦,我要试试!',
    explainerButton: '明白啦,我要试试!',
    streakLearn: '连对就学会',
    streakReview: '连对就过关',
    doneTitle: '今天的窍门学会啦!',
    doneSub: '明天再复习一次,就记得更牢啦',
    reviewedSub: (when) => `记得牢牢的,${when}再来复习`,
    cheers: ['答对啦!', '真厉害!', '太棒了!', '就是这样!', '好眼力!'],
    swapOwnerLabel: (name) => `不是${name}?换个小主人`,
    swapOwnerConfirm: (name) => `换个小主人?${name}下次用主人名和暗号就能回来。`,
    codeHint: '可以请爸爸妈妈帮你记下来哦',
    roundLabel: '这一程',
    roundDoneTitle: '这一程闯完啦!',
    roundFirstTry: (n, total) => `${total} 关里,一下子就闯过 ${n} 关`,
    roundLearned: '这一程学会了',
    roundAgain: '再闯一程!',
    roundSeeResult: '看看这一程的成绩',
    medals: { gold: '金牌', silver: '银牌', bronze: '铜牌', effort: '勤学章' },
    medalSub: {
      gold: '几乎关关一下子就闯过,太厉害了!',
      silver: '大部分关一下子就闯过,真棒!',
      bronze: '一半以上一下子就闯过,继续加油!',
      effort: '每一关都坚持闯过去了,下一程会更顺!',
    },
    roundLegendFirst: '一下子就过',
    roundLegendRetry: '想了想才过',
  },
  '9-12': {
    eggSubtitle: '选定你的灵兽起源,开启修行之旅',
    retryHint: '再想想,换个角度看看 ✨',
    capsuleButton: '再试一次',
    explainerButton: '明白了,动手试试',
    streakLearn: '连对即可掌握',
    streakReview: '连对即可过关',
    doneTitle: '这个本领已掌握',
    doneSub: '明天再复习一次,记忆会更牢固',
    reviewedSub: (when) => `已经记牢,${when}再来复习`,
    cheers: ['漂亮!', '思路清晰!', '稳!', '有两下子!', '好眼力!'],
    swapOwnerLabel: (name) => `不是${name}?切换身份`,
    swapOwnerConfirm: (name) => `切换身份?${name}下次用主人名和暗号就能回来。`,
    codeHint: '记不住就抄下来或截图保存',
    roundLabel: '这一程',
    roundDoneTitle: '这一程完成',
    roundFirstTry: (n, total) => `${total} 关里,一次就过 ${n} 关`,
    roundLearned: '这一程掌握了',
    roundAgain: '再来一程',
    roundSeeResult: '查看这一程的成绩',
    medals: { gold: '金牌', silver: '银牌', bronze: '铜牌', effort: '勤学章' },
    medalSub: {
      gold: '几乎每关一次通过,实力过硬',
      silver: '大部分一次通过,很稳',
      bronze: '过半一次通过,再接再厉',
      effort: '每一关都坚持拿下了,下一程会更顺',
    },
    roundLegendFirst: '一次通过',
    roundLegendRetry: '多试几次才过',
  },
};

/** 年龄段未知时回退到 6-8 的文案 */
export function getCopy(ageBand) {
  return COPY[ageBand] || COPY['6-8'];
}

/** 选年龄页还没有 ageBand,用对两个学段都不幼稚的中性说法 */
export const PICK_AGE_TITLE = '选择你的年龄段';
